import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="express-screener"
//
// Powers the "Change household size" modal on the express charity-care screener. Picking a
// size updates the over/under question in place — the title threshold, both option labels,
// the household-size display, and the hidden household_size field — using a precomputed
// { size: threshold } map, so no page reload is needed. (The over/under answer posts a static
// "under"/"over" bracket, so the radio values themselves don't change with size.)
export default class extends Controller {
  static targets = ["modal", "thresholdLabel", "sizeLabel", "householdSizeField", "numberButton"]
  static values = { thresholds: Object }

  open() { this.modalTarget.classList.remove("hidden") }
  close() { this.modalTarget.classList.add("hidden") }

  select(event) {
    const size = parseInt(event.currentTarget.dataset.size, 10)
    const threshold = this.thresholdsValue[size]
    if (threshold === undefined) { this.close(); return }

    const formatted = this.currency(threshold)
    this.thresholdLabelTargets.forEach((el) => { this.updateThresholdLabel(el, formatted) })
    if (this.hasSizeLabelTarget) this.sizeLabelTarget.textContent = size
    if (this.hasHouseholdSizeFieldTarget) this.householdSizeFieldTarget.value = size
    // The selected over/under answer stays selected as-is (its value is a static "under"/"over"
    // bracket); only the displayed threshold labels change with the new size.

    this.numberButtonTargets.forEach((b) => {
      const selected = parseInt(b.dataset.size, 10) === size
      b.classList.toggle("bg-core-purple-500", selected)
      b.classList.toggle("text-white", selected)
      b.classList.toggle("border-core-purple-500", selected)
    })

    this.close()
  }

  currency(value) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value)
  }

  updateThresholdLabel(el, formatted) {
    const jackpotNumber = this.application.getControllerForElementAndIdentifier(el, "jackpot-number")
    if (jackpotNumber) {
      jackpotNumber.setValue(formatted)
    } else {
      el.textContent = formatted
    }
  }
}
